export interface MangaChapter {
  id: string;
  title: string;
  chapterNumber: number;
  images: string[];
  updateDate: string;
}

export interface Manga {
  id: string;
  title: string;
  altTitle: string;
  author: string;
  artist: string;
  category: string;
  tags: string[];
  description: string;
  coverImage: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  updateDate: string;
  chapters: MangaChapter[];
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'slice-of-life', name: '日常', icon: 'ri-sun-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'bl', name: 'BL', icon: 'ri-hearts-line' },
  { slug: 'gl', name: 'GL', icon: 'ri-heart-add-line' },
];

export const mangas: Manga[] = [
  {
    id: 'goddess-descends',
    title: '女神降临',
    altTitle: '여신강림',
    author: '喵喵',
    artist: '喵喵',
    category: 'romance',
    tags: ['恋爱', '校园', '搞笑', '成长'],
    description: '相貌平平的女高中生任朱静，通过化妆术华丽变身为校园女神。然而，她一直小心翼翼地隐藏着自己的真实面貌，直到遇见了那个唯一看过她素颜的男孩李修豪。一段关于自信、成长与真爱的青春故事就此展开。任朱静在化妆与素颜之间徘徊，逐渐明白了真正的美丽来自内心的道理。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20high%20school%20girl%20with%20makeup%20transformation%20concept%2C%20soft%20romantic%20lighting%2C%20cherry%20blossom%20petals%2C%20warm%20pink%20and%20peach%20tones%2C%20digital%20manhwa%20art%20style%2C%20clean%20composition%2C%20elegant%20portrait&width=400&height=560&seq=manga-cover-goddess-01&orientation=portrait',
    status: '连载中',
    rating: 9.6,
    views: 2850000,
    favorites: 186000,
    updateDate: '2026-08-04',
    chapters: [],
  },
  {
    id: 'solo-leveling',
    title: '我独自升级',
    altTitle: '나 혼자만 레벨업',
    author: 'Chugong',
    artist: 'Jang Sung-rak',
    category: 'action',
    tags: ['动作', '奇幻', '冒险', '升级'],
    description: '在一个连接着异次元通道"门"的世界里，觉醒者们为了人类的存亡而战斗。最低级的E级猎人成振宇，在一次双重地下城事件中濒临死亡，却意外获得了独一无二的"升级系统"。从此，他成为了世界上唯一能够无限变强的存在。看一个最弱猎人如何一步步走向巅峰的传奇故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20shadow%20army%2C%20purple%20and%20black%20energy%20aura%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%2C%20digital%20manhwa%20art%2C%20epic%20composition&width=400&height=560&seq=manga-cover-solo-01&orientation=portrait',
    status: '已完结',
    rating: 9.8,
    views: 5200000,
    favorites: 320000,
    updateDate: '2026-07-28',
    chapters: [],
  },
  {
    id: 'omniscient-reader',
    title: '全知读者视角',
    altTitle: '전지적 독자 시점',
    author: 'sing N song',
    artist: 'Sleepy-C',
    category: 'fantasy',
    tags: ['奇幻', '末世', '冒险', '悬疑'],
    description: '金独子是一个普通上班族，唯一让他坚持下去的是追了十年的网络小说《在灭亡的世界中存活的三种方法》。当小说迎来最终话的那一刻，小说中的末日场景竟然在现实中上演了。作为唯一知道这个世界结局的人，金独子必须利用他对剧情的了解，在这个残酷的世界中生存下去。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20man%20holding%20a%20book%20in%20a%20post%20apocalyptic%20world%2C%20mysterious%20atmosphere%2C%20dark%20and%20warm%20contrasting%20tones%2C%20digital%20manhwa%20art%2C%20cinematic%20lighting&width=400&height=560&seq=manga-cover-reader-01&orientation=portrait',
    status: '连载中',
    rating: 9.7,
    views: 3100000,
    favorites: 245000,
    updateDate: '2026-08-03',
    chapters: [],
  },
  {
    id: 'sweet-trouble',
    title: '甜蜜的烦恼',
    altTitle: '달콤한 고민',
    author: '甜橙',
    artist: '甜橙',
    category: 'romance',
    tags: ['恋爱', '办公室', '甜宠', '日常'],
    description: '职场新人林小甜第一天上班就意外得罪了公司最年轻有为的部门总监。本以为会被穿小鞋，没想到这位冷面上司居然对她展开了温柔的攻势。一段发生在摩天大楼里的甜蜜办公室恋情，两个完全不同世界的人，会碰撞出怎样的火花？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20sweet%20couple%20in%20modern%20office%20setting%2C%20warm%20romantic%20atmosphere%2C%20soft%20lighting%20through%20windows%2C%20pink%20and%20cream%20tones%2C%20digital%20manhwa%20art%2C%20intimate%20composition&width=400&height=560&seq=manga-cover-sweet-01&orientation=portrait',
    status: '连载中',
    rating: 9.3,
    views: 1650000,
    favorites: 98000,
    updateDate: '2026-08-05',
    chapters: [],
  },
  {
    id: 'rebirth-cultivation',
    title: '重生之都市修仙',
    altTitle: '도시에서 수련하다',
    author: '玄机子',
    artist: '墨染',
    category: 'action',
    tags: ['动作', '修仙', '都市', '重生'],
    description: '一代仙尊林凡在渡天劫时被至交背叛，身死道消。当他再次睁开眼睛，发现自己重生回到了高中时代。带着前世数百年的修仙记忆，他要在这个灵气稀薄的现代都市中重新踏上修仙之路，有恩报恩，有仇报仇，这一次他不会再犯同样的错误。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20with%20spiritual%20energy%20surrounding%20him%20in%20a%20modern%20city%2C%20martial%20arts%20vibe%2C%20dramatic%20contrast%20between%20ancient%20and%20modern%2C%20digital%20manhwa%20art%2C%20powerful%20aura&width=400&height=560&seq=manga-cover-rebirth-01&orientation=portrait',
    status: '连载中',
    rating: 9.1,
    views: 2100000,
    favorites: 145000,
    updateDate: '2026-08-04',
    chapters: [],
  },
  {
    id: 'secret-life',
    title: '她的私生活',
    altTitle: '그녀의 사생활',
    author: '金成妍',
    artist: '金成妍',
    category: 'romance',
    tags: ['恋爱', '追星', '职场', '喜剧'],
    description: '成德美，美术馆首席策展人，职场上的完美女性。但没有人知道她私下是一个追星站姐，运营着一个拥有百万粉丝的偶像饭拍账号。当新任馆长莱恩·戈尔德入职后，德美的双重生活开始面临前所未有的挑战。这是一个关于隐藏身份与寻找真爱的暖心故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20woman%20with%20dual%20identity%20concept%2C%20half%20professional%20half%20casual%20fan%20mode%2C%20art%20gallery%20background%2C%20warm%20and%20vibrant%20tones%2C%20digital%20manhwa%20art%2C%20charming%20portrait&width=400&height=560&seq=manga-cover-secret-01&orientation=portrait',
    status: '已完结',
    rating: 9.4,
    views: 1890000,
    favorites: 132000,
    updateDate: '2026-06-15',
    chapters: [],
  },
  {
    id: 'office-romance',
    title: '社内相亲',
    altTitle: '사내 맞선',
    author: '海心',
    artist: 'Narak',
    category: 'comedy',
    tags: ['恋爱', '喜剧', '办公室', '契约'],
    description: '申夏莉替闺蜜去相亲，本想用浮夸演技吓退对方，没料到相亲对象竟然是公司的社长姜泰武。更糟糕的是，社长不仅看穿了她的小把戏，还提出了一个她无法拒绝的提议——假扮他的未婚妻。一场啼笑皆非的社内恋爱喜剧就此拉开帷幕！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20man%20and%20woman%20in%20elegant%20business%20attire%20sharing%20a%20playful%20moment%2C%20upscale%20restaurant%20background%2C%20romantic%20comedy%20vibe%2C%20warm%20golden%20lighting%2C%20digital%20manhwa%20art&width=400&height=560&seq=manga-cover-office-01&orientation=portrait',
    status: '已完结',
    rating: 9.5,
    views: 2450000,
    favorites: 178000,
    updateDate: '2026-05-20',
    chapters: [],
  },
  {
    id: 'itaewon-class',
    title: '梨泰院Class',
    altTitle: '이태원 클라쓰',
    author: '赵光真',
    artist: '赵光真',
    category: 'drama',
    tags: ['剧情', '创业', '复仇', '励志'],
    description: '因为一场事故失去父亲、被学校开除、甚至入狱的朴世路，出狱后踏上了创业之路。他在首尔最繁华的梨泰院开设了属于自己的小酒馆"甜夜"，与一群志同道合的伙伴们一起，向巨大的餐饮集团"张家"发起了挑战。坚持信念的不屈人生，在此绽放。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20determined%20young%20entrepreneur%20standing%20in%20front%20of%20a%20restaurant%20at%20night%20in%20Itaewon%2C%20neon%20signs%2C%20urban%20night%20atmosphere%2C%20digital%20manhwa%20art%2C%20dramatic%20lighting&width=400&height=560&seq=manga-cover-itaewon-01&orientation=portrait',
    status: '已完结',
    rating: 9.7,
    views: 3800000,
    favorites: 290000,
    updateDate: '2026-04-10',
    chapters: [],
  },
  {
    id: 'mystery-island',
    title: '迷雾之岛',
    altTitle: '안개의 섬',
    author: '黑影',
    artist: '冷月',
    category: 'thriller',
    tags: ['悬疑', '惊悚', '推理', '生存'],
    description: '十名互不相识的人收到神秘邀请，来到一座与世隔绝的私人岛屿参加生存游戏。丰厚的奖金让每个人都无法拒绝，但很快他们发现这是一场致命陷阱。岛上隐藏着不可告人的秘密，而参与者一个接一个地离奇消失。谁是幕后黑手？谁又能活到最后？',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20foggy%20island%20with%20silhouettes%20of%20people%2C%20thriller%20atmosphere%2C%20dark%20moody%20tones%20with%20muted%20greens%20and%20grays%2C%20digital%20manhwa%20art%2C%20suspenseful%20composition&width=400&height=560&seq=manga-cover-mystery-01&orientation=portrait',
    status: '连载中',
    rating: 9.0,
    views: 1250000,
    favorites: 87000,
    updateDate: '2026-08-02',
    chapters: [],
  },
  {
    id: 'daily-sunshine',
    title: '阳光正好',
    altTitle: '햇살 좋은 날',
    author: '暖阳',
    artist: '暖阳',
    category: 'slice-of-life',
    tags: ['日常', '治愈', '友情', '成长'],
    description: '在首尔的一家小咖啡馆里，四位性格迥异的年轻人因为一杯咖啡而结缘。温柔的咖啡师、忙碌的上班族、自由奔放的画家、安静内向的大学生——他们的日常交织在一起，构成了温暖人心的小故事。生活或许平凡，但阳光正好，一切都刚刚好。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cozy%20cafe%20with%20young%20people%20enjoying%20coffee%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20healing%20slice%20of%20life%20vibe%2C%20soft%20cream%20and%20beige%20tones%2C%20digital%20manhwa%20art&width=400&height=560&seq=manga-cover-sunshine-01&orientation=portrait',
    status: '连载中',
    rating: 9.2,
    views: 980000,
    favorites: 72000,
    updateDate: '2026-08-01',
    chapters: [],
  },
  {
    id: 'blossom-season',
    title: '花开时节',
    altTitle: '꽃 피는 계절',
    author: '春风',
    artist: '花语',
    category: 'bl',
    tags: ['BL', '校园', '青春', '慢热'],
    description: '转学到新学校的韩智浩，在樱花盛开的校园里遇见了学生会会长林修贤。一个是安静内敛的转校生，一个是阳光开朗的人气王。两个看似没有交集的人，在春天的校园里慢慢走近彼此的内心。一段青涩而美好的校园恋情，在花开的季节悄然绽放。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20two%20young%20men%20under%20cherry%20blossom%20trees%20in%20a%20school%20campus%2C%20soft%20spring%20atmosphere%2C%20gentle%20pink%20and%20white%20tones%2C%20digital%20manhwa%20art%2C%20tender%20romantic%20composition&width=400&height=560&seq=manga-cover-blossom-01&orientation=portrait',
    status: '连载中',
    rating: 9.3,
    views: 1420000,
    favorites: 105000,
    updateDate: '2026-08-03',
    chapters: [],
  },
  {
    id: 'sword-legend',
    title: '剑之传说',
    altTitle: '검의 전설',
    author: '铁刃',
    artist: '墨武',
    category: 'action',
    tags: ['动作', '武侠', '奇幻', '热血'],
    description: '在一个剑术为尊的世界里，出身贫寒的少年陈霄手持祖传残剑，踏入了大陆最强剑术学院。面对天才辈出的竞争者和暗流涌动的阴谋，他必须凭借超凡的意志和神秘的残剑之力，一步步攀登剑道巅峰。一剑在手，天下我有！',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20sword%20in%20an%20ancient%20fantasy%20setting%2C%20dramatic%20action%20pose%2C%20golden%20and%20crimson%20energy%2C%20digital%20manhwa%20art%2C%20epic%20heroic%20composition&width=400&height=560&seq=manga-cover-sword-01&orientation=portrait',
    status: '连载中',
    rating: 9.4,
    views: 1980000,
    favorites: 156000,
    updateDate: '2026-08-05',
    chapters: [],
  },
];

export const faqs = [
  {
    question: '樱花动漫网是什么？',
    answer: '樱花动漫网是一个专注于韩漫下拉式在线阅读的中文平台，提供海量高清韩漫资源，支持流畅的下拉式阅读体验。无论您喜欢恋爱、奇幻、动作还是悬疑题材，都能在这里找到心仪的作品。',
  },
  {
    question: '阅读韩漫需要付费吗？',
    answer: '樱花动漫网上的所有韩漫资源均可免费阅读。我们致力于为广大漫画爱好者提供无障碍的阅读体验，无需注册即可畅享精彩内容。部分独家作品可能会有免费阅读章节限制，但绝大部分内容完全免费。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是一种针对手机和网页优化的阅读方式，用户只需向下滑动屏幕即可连续阅读漫画内容，无需翻页。这种方式更加流畅自然，特别适合在移动设备上阅读长条漫和条漫格式的韩漫作品。',
  },
  {
    question: '如何找到我想看的韩漫？',
    answer: '您可以通过首页的搜索功能、分类导航或标签筛选来找到感兴趣的韩漫。我们提供了恋爱、奇幻、动作、日常、悬疑等多个分类，以及热门排行和最新更新列表，帮助您快速发现精彩内容。',
  },
  {
    question: '网站多久更新一次内容？',
    answer: '樱花动漫网保持每日更新频率。我们团队持续关注韩漫最新动态，第一时间为您带来最新的章节更新和新作推荐。首页的"最新更新"板块会展示最近更新的漫画列表。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！樱花动漫网采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备访问，都能获得流畅舒适的下拉式阅读体验。推荐使用移动设备竖屏阅读，效果最佳。',
  },
];

export const testimonials = [
  {
    id: '1',
    name: '小林',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20young%20woman%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20digital%20art&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '终于找到一个可以免费看韩漫的平台了！下拉式阅读体验太爽了，界面也很漂亮。每天都要上来追更新～',
    date: '2026-07-15',
  },
  {
    id: '2',
    name: '阿星',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20young%20man%20with%20glasses%2C%20friendly%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20digital%20art&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '资源真的超全！我之前找了很久的几部韩漫这里都有，而且画质很好。推荐给了好多朋友，大家都说好用。',
    date: '2026-07-22',
  },
  {
    id: '3',
    name: '小雨点',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20portrait%20of%20a%20young%20woman%20with%20long%20hair%2C%20gentle%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20digital%20art&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    comment: '页面设计很舒服，分类也很清晰。希望能增加更多完结作品，追连载等更新太煎熬了哈哈。整体很喜欢！',
    date: '2026-08-01',
  },
];